/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  DeleteApiV1ExamQuestionLibraryItemIdMutationResponse,
  DeleteApiV1ExamQuestionLibraryItemIdPathParams,
  DeleteApiV1ExamQuestionLibraryItemId400,
  DeleteApiV1ExamQuestionLibraryItemId401,
  DeleteApiV1ExamQuestionLibraryItemId404,
  DeleteApiV1ExamQuestionLibraryItemId500,
} from "../../types/examQuestionLibraryController/DeleteApiV1ExamQuestionLibraryItemId.ts";

function getDeleteApiV1ExamQuestionLibraryItemIdUrl(
  id: DeleteApiV1ExamQuestionLibraryItemIdPathParams["id"],
) {
  const res = {
    method: "DELETE",
    url: `/api/v1/exam/question-library/item/${id}` as const,
  };
  return res;
}

/**
 * @description Exclui permanentemente uma questão da biblioteca. Caso a questão possua arquivo anexado, ele também é removido do armazenamento. **(Requer Authorization para autenticação)**
 * @summary Excluir questão da biblioteca (Requer Authorization para autenticação)
 * {@link /api/v1/exam/question-library/item/:id}
 */
export async function deleteApiV1ExamQuestionLibraryItemId(
  id: DeleteApiV1ExamQuestionLibraryItemIdPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiV1ExamQuestionLibraryItemIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1ExamQuestionLibraryItemId400
      | DeleteApiV1ExamQuestionLibraryItemId401
      | DeleteApiV1ExamQuestionLibraryItemId404
      | DeleteApiV1ExamQuestionLibraryItemId500
    >,
    unknown
  >({
    method: "DELETE",
    url: getDeleteApiV1ExamQuestionLibraryItemIdUrl(id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
